module.exports = __webpack_public_path__ + "img/infoImg5.0c5ecca7.png";